export const VUE_APP_MODE = process.env.VUE_APP_MODE

export const PROTOCOL = location.protocol
// const host = location.host.replace('www', '').replace('app', '')

// 新方案适配无www/app前缀的情况
let host = ''
if (location.host.indexOf('www') !== -1 || location.host.indexOf('app') !== -1) {
  host = location.host.replace('www', '').replace('app', '')
} else {
  host = '.' + location.host
}

export const CPSHOST = host.indexOf('localhost') !== -1 || host.indexOf('127.0.0.1') !== -1 ? 'cps-server.eline56.test' : 'cps-server' + host
export const CPSURL = host.indexOf('localhost') !== -1 || host.indexOf('127.0.0.1') !== -1 ? 'http://cps-server.eline56.test' : PROTOCOL + '//cps-server' + host
export const BASEURL = host.indexOf('localhost') !== -1 || host.indexOf('127.0.0.1') !== -1 ? 'http://gateway.eline56.test' : PROTOCOL + '//gateway' + host
